import { render } from "./NotificacoesBar.vue?vue&type=template&id=3aae4c8c&scoped=true"
import script from "./NotificacoesBar.vue?vue&type=script&lang=js"
export * from "./NotificacoesBar.vue?vue&type=script&lang=js"

import "./NotificacoesBar.vue?vue&type=style&index=0&id=3aae4c8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aae4c8c"]])

export default __exports__